<template>
    <v-flex sm12>
        <h3>{{ titulo }}</h3>
    </v-flex>
</template>

<script>
export default {
    name    : 'TituloPagina',
    props   : {
        titulo : {
            type     : String,
            required : true
        },
    },
};
</script>
